type TFetchDataQueryParamValue = string | number | boolean | Date | null | undefined;

type TFetchDataQueryParams = Record<string, TFetchDataQueryParamValue>;

export const fetchData = async (endpoint: string, queryParams?: TFetchDataQueryParams) => {
	try {
		const url = new URL(endpoint);

		if (queryParams) {
			Object.entries(queryParams).forEach(([key, value]) => {
				if (value !== undefined && value !== null && value !== "") {
					url.searchParams.set(key, value.toString());
				}
			});
		}

		const response = await fetch(url);
		const data = await response.json();

		return data;
	} catch (error) {
		console.error(`Error occurred while fetching ${endpoint}`, error);

		return null;
	}
};
